module.exports = __webpack_public_path__ + "media/edigest_2019.590be841.mp4";